module.exports = __webpack_public_path__ + "media/images/convenios/col_kinesiologos (copia)-f4a565e3995cc7b2fda2c1aba84de2b4.jpg";